import { Component, ElementRef } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { AmazonStoreCredentials } from "../../../../objects/amazon/AmazonStoreCredentials";
import { Seller } from "../../../../objects/amazon/seller";
import { AmazonService } from "../../../../services/amazon.service";
import { AmazonProduct } from "../../../../objects/amazon/AmazonProduct";
import { BaseResponse } from "../../../../objects/common/baseResponse";
import { BaseSearchRequest } from "../../../../objects/requests/baseSearchRequest";
import { SearchResponse } from "../../../../objects/responses/searchResponse";
import { SortType } from "../../../../objects/users/user";
import { Component as ComponentEnum } from "../../../../objects/components/component";
import { UploadService } from "../../../../services/uploadService";
import { ConfigService } from "../../../../services/configService";
import { HTCCodeHelper } from "../../../../common/helpers/HTCCodeHelper";

@Component({
    selector: 'amazon-store-management',
    templateUrl: 'amazon-store-management.html',
    moduleId: module.id.toString()
})
export class AmazonStoreManagement {
    public sellerId: string;
    public storeId: string;

    public store: AmazonStoreCredentials = new AmazonStoreCredentials();
    public seller: Seller = new Seller();
    public HTCCodeHelper = HTCCodeHelper;

    public config = {
        currentPage: 0,
        itemsPerPage: 50,
        totalItems: 0
    };

    public readonly headerHeight = 60;
    public readonly rowHeight = 50;

    private currentSortProp: string = null;
    private isAscending: boolean = null;
    private isLoading: boolean = false;

    constructor(private activatedRoute: ActivatedRoute,
                private route: ActivatedRoute,
                public amazonService: AmazonService,
                private el: ElementRef,
                private uploadService: UploadService,
                private configService: ConfigService) {

    }

    ngOnInit() {
        this.seller = this.route.snapshot.data.seller;

        this.activatedRoute.params.subscribe((params: Params) => {
            this.sellerId = params['sellerId'];
            this.storeId = params['storeId'];

            this.showStore(this.storeId);
        });
    }

    public showStore(storeId: string) {
        this.store = this.seller.Stores.find(store => store.Id == storeId);

        const products = this.route.snapshot.data.products;

        this.store.Products = [...products.Items];

        this.config.totalItems = this.store.TotalCount;
        this.config.currentPage++;
    }

    public loadProducts(reset: boolean = false): void {
        if (this.isLoading == true)
            return;

        this.isLoading = true;

        this.amazonService.getProducts(this.sellerId, this.storeId, this.config.currentPage * this.config.itemsPerPage, this.config.itemsPerPage, true, this.currentSortProp, this.isAscending)
            .then((response: BaseResponse<SearchResponse<AmazonProduct>>) => {
                this.isLoading = false;

                if (reset)
                    this.store.Products = response.Data.Items;
                else
                    this.store.Products.push(...response.Data.Items);

                this.store.Products = [...this.store.Products];
            })
    }

    public onScroll(scrollY: any) {
        if (!scrollY || !scrollY.offsetY)
            return;
        // total height of all rows in the viewport
        const viewHeight = this.el.nativeElement.getBoundingClientRect().height - this.headerHeight;

        if (this.config.currentPage * this.config.itemsPerPage >= this.config.totalItems)
            return;

        if (viewHeight + scrollY.offsetY >= this.store.Products.length * this.rowHeight) {
            this.config.currentPage++;

            this.loadProducts();
        }
    }

    public handleSort(event: any): void {
        this.isAscending = event.newValue == 'asc';
        this.currentSortProp = event.column.prop;
        this.config.currentPage = 0;
        this.loadProducts(true);
    }

    public updateProduct(product: AmazonProduct, hsCode: string): void {
        product.HsCode = hsCode;
        this.amazonService.updateProduct(this.sellerId, this.storeId, product);
    }

    public exportProducts(): void {
        window.open(`${this.configService.config.AdminUrl}/management/amazon/seller/${this.sellerId}/store/${this.storeId}/export`, '_blank');
    }

}


// WEBPACK FOOTER //
// ./app/components/Managment/amazon-management/store/amazon-store-management.ts